import {
  AuthorizedUiElementServiceProvider,
  AuthorizedUiElementConfig,
} from "../../../../ui/authorizedUiElement";
import { StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../../application/UserProfile";

export const vsMultiServiceName = "multiMachineChangeChildStateService";
export const vsMultiProviderName = `${vsMultiServiceName}Provider`;

export interface MultipleMachineChangeChildStateConfig
  extends AuthorizedUiElementConfig {}

export class MultipleMachineChangeChildStateServiceProvider extends AuthorizedUiElementServiceProvider<MultipleMachineChangeChildStateConfig> {
  override $get = [
    "userProfile",
    "$state",
    (userProfile: UserProfile, $state: StateService) =>
      this.defaultServiceFactory(userProfile, $state),
  ];

  override basePath: string = "main.machines";
}
